export default {
  common: {
    help: "Do you have questions about your claim?",
    call: "Call",
    phone: "1 800 549 7227",
    previous: "Previous",
    next: "Next",
    cancel: "Cancel",
    ok: "OK",
    cancelTitle: "Caution",
    cancelMsg: "You are preparing to exit the form. All information entered will be lost. Do you wish to continue?",
    submit: "Submit", 
    error: "Please correct any errors on the page before continuing",
    errorSubmit: "There was an error in submitting your claim. Please print and/or save this page and call our Customer Service at 1 800 549 7227"
  },
  landing_page: {
    header1: "File a claim",
    header2: "The following claims can be reported online: ",
    disabilityLink: "Disability",
    header3:
      "To report the claims listed below, contact our Claims Customer Service at ",
    lifeLink: "Life",
    ciLink: "Critical Illness",
    empLink: "Involuntary Unemployment",
    header4: "Other ways to file a claim",
    subheader1: "Contact Customer Service",
    paragraph1: "We will assist you on how to proceed with your claim.",
    paragraph2: "Contact us ",
    subheader2: "Complete a PDF form",
    paragraph3:
      "Complete the necessary forms and return them with any required documentation.",
    paragraph4: "Forms",
    subheader3: "Track a claim",
    trackerLink: "Access claims tracker >",
    disForm: "Disability Claims Forms", 
    lifeForm: "Life Claims Forms",
    ciForm: "Critical Illness Forms",
    emailSecurityMsg: "We wish to remind you that email is not a secure method of communication and should only be used to transmit non-confidential information.",
    faqPdf: "Creditor Claims FAQ – Disability"
  },
  section_intro: {
    header1: "File a Claim",
    paragraph1:
      "This form makes it possible to file a creditor disability claim online.  It should take approximately 15 minutes to complete. If you want to file your claim by phone? Dial",
    paragraph2: "You will be asked to provide information about:",
    list1: "the vehicle dealership where you purchased this insurance coverage",
    list2: "the financial institution where your loan or lease is held",
    list3: "the medical condition causing your disability",
    list4: "dates you sought medical attention ",
    list5: "your physician’s name and contact information ",
    list6: "your employment ",
    paragraph3: "Have this information ready before you begin."
  },
  section_contact: {
    paragraph1: "Please contact our Claims Customer Service at",
    header2: "Address",
    paragraph2: "You will receive an acknowledgement of receipt after the claim is sent."
  },
  section_certificateFinancial: {
    header2: "Dealership Information",
    header3: "Loan or Lease Details"
  },
  section_disability: {
    header2: "Medical Consultation for this condition",
    header3: "Medical History"
  },
  section_accident: {
  },
  section_occupation: {
    header2: "Your Self-employment"
  },
  section_comments: {
  },
  section_summary: {
    header1: "Summary",
    section1: "Edit Contact Section",
    section2: "Edit Certification Section",
    section3: "Edit Disability Section",
    section4: "Edit Accident Section",
    section5: "Edit Occupation Section",
    section6: "Edit Comments Section"
  },
  section_confirmation: {
    header1: "Confirmation",
    header2: "We have received your claim.",
    paragraph1:
      "You will receive an email containing your tracking number and related information."
  }
};
